import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * @file Created on Mon Aug 06 2018
 * @author VBr
 */


import { Family } from '@logio/common-be-fe';
import { List } from 'immutable';
import { action, observable, runInAction } from 'mobx';
import { FamilyLayer } from '../../transportLayers/family/FamilyLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/**
 * This store obtaining data of price zones.
 */

export var FamilyStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(FamilyStore, _BaseStore);

  function FamilyStore() {
    var _this;

    _classCallCheck(this, FamilyStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FamilyStore).apply(this, arguments));
    _this.name = StoreName.Family;
    _this.productStore = _this.rootStore.getStore(StoreName.Product);
    _this.familyLayer = new FamilyLayer();
    _this.list = new Map();

    _this.setBindings = function (updates) {
      return _this.familyLayer.setBindings(updates).then(function (families) {
        runInAction(function () {
          families.forEach(function (family) {
            _this.list.set(family.id, family);
          });
        });
        return families;
      });
    };

    return _this;
  }

  _createClass(FamilyStore, [{
    key: "getAll",
    value: function getAll() {
      var _this2 = this;

      this.list.clear();
      return this.familyLayer.findAll().then(function (families) {
        runInAction(function () {
          families.forEach(function (family) {
            _this2.list.set(family.id, family);
          });
        });
      });
    }
  }, {
    key: "getInCategory",
    value: function getInCategory(categoryId) {
      var _this3 = this;

      this.list.clear();
      return this.familyLayer.findInCategory(categoryId).then(function (families) {
        runInAction(function () {
          families.forEach(function (family) {
            _this3.list.set(family.id, family);
          });
        });
      });
    }
  }, {
    key: "getOne",
    value: function getOne(familyId) {
      var _this4 = this;

      return this.familyLayer.findOne(familyId).then(function (family) {
        runInAction(function () {
          _this4.list.set(family.id, family);
        });
        return family;
      });
    }
  }, {
    key: "update",
    value: function update(family) {
      var _this5 = this;

      return this.familyLayer.update(family).then(function (updatedFamily) {
        runInAction(function () {
          _this5.list.set(updatedFamily.id, updatedFamily);
        });
      });
    }
  }, {
    key: "create",
    value: function create(family) {
      var _this6 = this;

      return this.familyLayer.create(family).then(function (newFamily) {
        runInAction(function () {
          _this6.list.set(newFamily.id, newFamily);
        });
        return newFamily;
      });
    }
  }, {
    key: "createWithAffected",
    value: function createWithAffected(newFamily) {
      var _this7 = this;

      return this.familyLayer.createWithAffected(newFamily).then(function (data) {
        runInAction(function () {
          _this7.list.set(data.family.id, data.family);

          data.affectedFamilies.forEach(function (family) {
            _this7.list.set(family.id, family);
          });
        });
        return data;
      });
    }
  }, {
    key: "updateTier",
    value: function updateTier(updates) {
      var _this8 = this;

      return this.familyLayer.updateTier(updates).then(function (families) {
        runInAction(function () {
          families.forEach(function (family) {
            _this8.list.set(family.id, family);
          });
        });
      });
    }
  }, {
    key: "updateName",
    value: function updateName(updates) {
      var _this9 = this;

      return this.familyLayer.updateName(updates).then(function (families) {
        runInAction(function () {
          families.forEach(function (family) {
            _this9.list.set(family.id, family);
          });
        });
      });
    }
  }]);

  return FamilyStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], FamilyStore.prototype, "list", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], FamilyStore.prototype, "getAll", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], FamilyStore.prototype, "getInCategory", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], FamilyStore.prototype, "getOne", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Family]), __metadata("design:returntype", Promise)], FamilyStore.prototype, "update", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Family]), __metadata("design:returntype", Promise)], FamilyStore.prototype, "create", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Family]), __metadata("design:returntype", Promise)], FamilyStore.prototype, "createWithAffected", null);

__decorate([action, __metadata("design:type", Object)], FamilyStore.prototype, "setBindings", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], FamilyStore.prototype, "updateTier", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], FamilyStore.prototype, "updateName", null);